import React from 'react';

import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import DisplayCard from '../../components/displaycard';
import Auth from '../../data/auth-service';
import Permissions from '../../data/permissions';

const useStyles = makeStyles(theme => ({
    card: {
        maxWidth: 345,
    },
}));

const options = [
    {
        title: 'Users & Roles',
        description: 'Create and update users and roles',
        img: '/images/users-roles.png',
        route: '/system/users_roles',
        perm: {
            Users: [...Permissions.System.Users],
            Roles: [...Permissions.System.Roles],
        },
    },
    {
        title: 'Configuration',
        description: 'Manage settings for health, reports, audits, etc.',
        img: '/images/configuration.png',
        route: '/system/configuration',
        perm: { Configuration: { ...Permissions.System.Configuration } },
    },
    {
        title: 'Network Traffic Mirroring',
        description: 'Setup port Mirroring on AWS & GCP ',
        img: '/images/aws.png',
        route: '/system/port_mirroring',
        perm: { Mirroring: { ...Permissions.System.Mirroring } },
    },
    {
        title: 'CMC Health',
        description: 'Extensive reporting on the health of the CMC',
        img: '/images/health.png',
        route: '/system/cmc_health',
        perm: { SystemHealth: [...Permissions.System.SystemHealth] },
    },
    {
        title: 'Anomaly Detection',
        description: 'Configure anomaly detection rules and settings',
        img: '/images/configuration.png',
        route: '/system/anomaly_detection',
        perm: { Anomolies: { ...Permissions.System.AnomalyDetection } },
    },
    {
        title: 'Assets',
        description: 'Create and configure name and address mappings',
        img: '/images/assets.png',
        route: '/system/assets',
        perm: { Assets: [...Permissions.Assets] },
    },
    {
        title: 'Audit',
        description: 'A report of audited user actions on the OpenText™ NDR system',
        img: '/images/audit.png',
        route: '/system/audit',
        perm: { Audit: [...Permissions.System.Audit] },
    },
    {
        title: 'Reports',
        description: 'Create automated alerts reports and view previously export reports',
        img: '/images/reports.png',
        route: '/system/reports',
        perm: { Reports: [...Permissions.System.Reports] },
    },
    {
        title: 'License',
        description: 'Manage the license of the OpenText™ NDR system',
        img: '/images/license.png',
        route: '/system/license',
        perm: { License: [...Permissions.System.License] },
    },
    {
        title: 'Upgrades',
        description: 'Upgrade CMC and data node(s)',
        img: '/images/update.png',
        route: '/system/upgrades',
        perm: { ...Permissions.System.Upgrades },
    },
];

const System = (props) => {
    const classes = useStyles();

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {options.filter(o => Auth.perm(o.perm)).map((p, i) => {
                    return (
                        <Grid item xl={3} lg={4} key={`policies-zeek-${i}`}>
                            <DisplayCard {...p} noButton />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default System;
